<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app">
            <v-app id="inspire">
                <v-card v-model="show" color="#FFFF99">
                    <v-card-title>
                        <v-row justify="center" align="center">
                            <v-col cols="9" class="text-center">
                                REGISTRO DE REQUISITOS LEGALES
                            </v-col>
                            <v-col cols="2" class="text-center">
                                EI 303
                            </v-col>
                            <v-col cols="1" class="text-center">
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text class="pt-2">
                        <v-row justify="center" align="center">
                            <v-col cols="10" class="text-center">
                                <h6> {{ tituloaspecto }}{{ tituloalcance }} </h6>
                            </v-col>
                            <v-col cols="2" class="text-center">
                                <v-text-field dense label="Fecha" v-model="fecha"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense label="Sitio" v-model="sitio"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense label="Referencia" v-model="referencia"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense label="Evaluador" v-model="evaluador"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="1">
                                <v-text-field dense label="EI 303 - Revisión" v-model="revision"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-data-table dense :headers="headers" :items="listado" group-by="tipo" locale="es-ar"
                    class="elevation-1" :items-per-page="400" hide-default-footer :loading="loadtable"
                    loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                    <template v-slot:group.header="{ items }">
                        <td :colspan="headers.length" class="text-xs-right" style="color: green;">
                            <strong>{{ items[0].tipo }}</strong>
                        </td>
                    </template>
                    <template v-slot:item.cumplimiento="{ item }">
                        <v-select dense outlined v-model="item.cumplimiento" :items="itemscumpl" item-text="nombre"
                            item-value="valor" class="font-class-name2"></v-select>
                    </template>
                    <template v-slot:item.observ="{ item }">
                        <v-textarea dense v-model="item.observ" rows="2" auto-grow outlined
                            class="font-class-name2"></v-textarea>
                    </template>
                </v-data-table>
                <v-card color="#FFFF99" tile>
                    <v-card-actions>
                        <div class="w-20">
                            <v-select dense label="Estado" outlined v-model="estado" :items="estados" item-text="nombre"
                                item-value="valor">
                            </v-select>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-app>
        </div>
    </v-dialog>
</template>
<style scoped>
::v-deep .w-20 {
    width: 20% !important;
}
</style>
<style scoped>
.font-class-name2 {
    font-size: 12px !important;
}

::v-deep .v-data-table .v-data-table__wrapper td {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

::v-deep .v-data-table .v-data-table-header tr th {
    font-size: 12px !important;
    padding: 2px 4px !important;
}
</style>
<script>
import axios from "../../../axios-auth.js";
// import VerInforme from "../Requisitos/Informe.vue";
export default {
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        listado: [],
        tituloalcance: "",
        tituloaspecto: "",
        tipoalcance: "",
        tipoaspecto: "",
        sitio: "",
        referencia: "",
        evaluador: "",
        fecha: "",
        revision: "",
        estado: "",
        codigoeval: "",
        loadtable: false,
        deshabilitar: false,
        itemscumpl: [{ nombre: "-", valor: "" },
        { nombre: "N/A", valor: "NA" },
        { nombre: "NO", valor: "NO" },
        { nombre: "SI", valor: "SI" },
        ],
        estados: [{ nombre: "Pendiente", valor: "P" },
        { nombre: "Cerrado", valor: "C" },
        ],
        headers: [
            { text: "Tipo", align: "center", sortable: false, value: "tipo", width: "10%" },
            { text: "Código", align: "center", sortable: false, value: "codigo", width: "10%" },
            { text: "Norma", value: "norma", sortable: false, width: "15%" },
            { text: "Organismo Emisor", value: "emisor", sortable: false, width: "15%" },
            { text: "Obligaciones", value: "oblig", sortable: false, width: "30%" },
            { text: "Cumplimiento", value: "cumplimiento", align: "center", width: "5%", sortable: false },
            { text: "Observaciones", value: "observ", align: "center", width: "20%", sortable: false },
        ],
    }),
    props: ["visible", "codeval"],
    watch: {
        estado: 'verificarCondiciones',
    },

    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargardatos();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        verificarCondiciones() {
            console.log("Estado ", this.listado)
            if (this.estado == "C") {
                const hayCumplimientosVacios = this.listado.some(item => item.cumplimiento === "");

                if (hayCumplimientosVacios) {
                    console.log("hay ")
                    this.deshabilitar = true
                    this.showAlert2({
                        icon: "error",
                        title: "No puede Cerrar sin completar todos los cumplimientos",
                        vm: this,
                        time: "5500",
                    });
                }
                else {
                    this.deshabilitar = false
                }
            }
            else {
                this.deshabilitar = false
            }
        },

        cargardatos() {
            this.loadtable = true;
            const codigo = this.codeval;
            let self = this;
            axios
                .get("/Sgi/Cargarrequisitosevaluacion?", {
                    params: {
                        codigo: codigo,
                    },
                })
                .then((response) => {
                    self.sitio = response.data.sitio;
                    self.fecha = response.data.fecha;
                    self.referencia = response.data.referencia;
                    self.evaluador = response.data.evaluador;
                    self.alcance = response.data.alcance;
                    self.aspecto = response.data.aspecto;
                    self.estado = response.data.estado;
                    self.revision = response.data.revision;
                    self.listado = response.data.cumplimiento;
                    self.loadtable = false;
                    if (response.data.aspecto == "M") {
                        self.tituloaspecto = "EVALUACIÓN DE CUMPLIMIENTO DE LA NORMATIVA MEDIOAMBIENTAL - ";
                        self.tipoaspecto = ""
                    }
                    if (response.data.aspecto == "S") {
                        self.tituloaspecto = "EVALUACIÓN DE CUMPLIMIENTO DE LA NORMATIVA SST - ";
                        self.tipoaspecto = " SST";
                    }
                    if (response.data.alcance == "M") {
                        self.tituloalcance = "MUNICIPAL";
                        self.tipoalcance = "M";
                    }
                    if (response.data.alcance == "P") {
                        self.tituloalcance = "PROVINCIAL";
                        self.tipoalcance = "P";
                    }
                    if (response.data.alcance == "N") {
                        self.tituloalcance = "NACIONAL";
                        self.tipoalcance = "N";
                    }
                    if (response.data.alcance == "C") {
                        self.tituloalcance = "CIUDAD AUTÓNOMA DE BUENOS AIRES";
                        self.tipoalcance = "CABA";
                    }
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });

        },


        // cargarcodigo() {
        //     let self = this;
        //     axios
        //         .get("/Sgi/CodigoEvaluacion?")
        //         .then((response) => {
        //             self.codigoeval = response.data;
        //             console.log("COD ", self.codigoeval)
        //         })
        //         .catch((error) => {
        //             self.codeval = "";
        //             console.log(error);
        //         });
        // },

        guardar() {
            this.$swal({
                title: "Editar Evaluación de cumplimiento",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;

                    var datos = {
                        codigoeval: this.codeval,
                        fecha: this.fecha,
                        sitio: this.sitio,
                        referencia: this.referencia,
                        evaluador: this.evaluador,
                        revision: this.revision,
                        estado: this.estado,
                        aspecto: this.aspecto,
                        alcance: this.alcance,
                        cumplimiento: this.listado,
                    };
                    let self = this;
                    axios
                        .post("/SGI/GuardarRequisitoEvaluacion", datos)
                        .then((response) => {
                            self.showAlert({
                                icon: "success",
                                title: "Requisito Legal guardado con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },

        showAlert2(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: alertInfo.time,
            });
        },
        vaciarModels() {

            this.aspecto = "";
            this.estado = "A";
            this.alcance = "";
            this.fecha = "";
            this.sitio = "";
            this.evaluador = "";
            this.referencia = "";
            this.revision = "";
            this.listado = [];
            this.deshabilitar = false;
            this.$router.push({ name: "Listadorequisitosevaluacion" });
        },
    },
};
</script>